<template>
  <div>
    <p>Loading the Preview...</p>
  </div>
</template>

<script>
export default {
  name: "Preview",
  async mounted() {
    const {token, documentId} = this.$route.query
    console.log( {route: this.$route, token, documentId})

    const linkResolver = function (doc) {
      // Pretty URLs for known types
      if (doc.type === 'lexiconentry') return "/protected/myFinHub/?preview=" + doc.id
      if (doc.type === 'contexthelpentry') return "/protected/myFinHub/?preview=" + doc.id
      // Fallback for other types, in case new custom types get created
      return "/"
    }

    this.$prismic.client.getPreviewResolver(token, documentId).resolve(linkResolver, '/')
    .then((url) => {
      console.log('url',url)
      this.$router.push(url)
    })
  }
}
</script>

<style scoped>

</style>
